var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RecycleScroller',{staticClass:"h-100 scroller w-auto stock-items-list",attrs:{"items":_vm.stockProducts,"item-size":90,"key-field":"PLU"},scopedSlots:_vm._u([{key:"default",fn:function({ item, index, active }){return [_c('Product',{attrs:{"stock":item},on:{"click":function($event){return _vm.addToSale(item)}}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }